import emrService from '@/apis/emr/service';
import NoDataYet from '@/components/NoDataYet';
import BaseIconSvg from '@/components/bases/BaseIconSvg';
import constants from '@/constants';
import emrTypeHelper from '@/helper/emrType';
import useActions from '@/hooks/useActions';
import FormCreateEmr from '@/screens/CreateEmr/FormCreateEmr';
import FormEditTagsEmr from '@/screens/CreateEmr/FormEditTagsEmr';
import useGlobalConfigs from '@/stores/globalConfigs';
import { useQuickModal } from '@/utils/quickModal';
import { Button, Flex, Skeleton, Tag, message } from 'antd';
import dayjs from 'dayjs';
import * as React from 'react';

export interface IViewDefaultProps {
  emrTypeCode?: string;
  emr?: IEMRData;
  _id?: string;
  emrType?: IEMRType;
}

const ViewDefault: React.FC<IViewDefaultProps> = ({ emr, _id: initialId, emrType, ...props }) => {
  const { quickModal, quickModalContext } = useQuickModal();
  const { isCMSView } = useActions();
  const [_id, set_Id] = React.useState<string | undefined>(initialId || emr?._id);
  // vì ban đầu ko có id
  const getEmrType = useGlobalConfigs((s) => s.getEmrType);
  const { data, refetch, isFetching } = emrService.useGetEmr({
    _id,
  });
  const emrData: IEMRData = data?.data?.[0] || emr;

  emrType = emrType || getEmrType(emrData?.type?.code);

  if (!emrType) {
    return <NoDataYet />;
  }

  return (
    <div
      onDoubleClick={() => {
        console.log({ emrType, emrData });
      }}
    >
      {quickModalContext}
      <Flex className="justify-end items-center px-2 pb-2">
        {emrType?.extra?.formDetail?.showInfo !== false && (
          <Tag className="rounded-full px-2 flex">
            <div className="">Phiếu khám : {emrData?.data?.code || '--'}</div> <div className="px-2">|</div>
            <div>Thời gian: {emrData?.date ? dayjs(emrData.date).format(constants.DATE_FORMAT) : '--'}</div>
          </Tag>
        )}

        {/* <EmrAction /> */}
        {!isCMSView && (
          <Button.Group size="small" className="ml-2">
            <Button
              className="rounded-xl flex items-center"
              onClick={() => {
                if (!emrTypeHelper.canEdit(emrData)) {
                  return message.warning(`Không thể sửa bản ghi được tạo ra từ hệ thống khác (${emrData.race})`);
                }
                quickModal.custom({
                  width: 900,
                  title: emrType?.name,
                  content: (
                    <FormCreateEmr
                      disabled={false}
                      emrTypeStringInit={emrType?.code}
                      initValues={emrData}
                      onOk={(modal, data) => {
                        if (data?.data?._id !== _id) {
                          set_Id(data?.data?._id);
                        } else {
                          refetch();
                        }
                        modal.close();
                      }}
                    />
                  ),
                });
              }}
            >
              <BaseIconSvg src="/icons/Regular/Edit - icon.svg" className="mr-2" />
              Chỉnh Sửa
            </Button>
            {emrType?.format?.fields?.find((f) => f.key === 'tags') && (
              <Button
                className="rounded-xl flex items-center"
                onClick={() => {
                  quickModal.custom({
                    width: 900,
                    title: 'Gắn thẻ',
                    content: (
                      <FormEditTagsEmr
                        emr={emr as IEMRData}
                        onOK={(modal, data) => {
                          modal.close();
                          data && refetch();
                        }}
                      />
                    ),
                  });
                }}
              >
                <BaseIconSvg src="/icons/Regular/Tag - icon.svg" className="mr-2" />
                Gắn thẻ
              </Button>
            )}
          </Button.Group>
        )}
      </Flex>

      {!isFetching ? (
        <FormCreateEmr disabled emrTypeStringInit={emrType?.code} initValues={emrData} />
      ) : (
        <div className="px-4">
          <Skeleton />
          <Skeleton />
          <Skeleton />
        </div>
      )}
    </div>
  );
};
export default ViewDefault;
